var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-image-element mb-10",attrs:{"id":_vm.item.key}},[(_vm.item.image && _vm.item.image[0])?_c('base-image',{attrs:{"url":_vm.item.image[0].url,"width":909,"height":390,"alt-text":_vm.item.imageAltText,"image-class":"m-image-element__image"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }